<template>
  <popup :show="show"
         title="寄件时间"
         confirm-btn-text="确定"
         @confirm="handleConfirm"
         @close="() => { $emit('close') }">
    <div class="datetime-picker">
      <div class="picker-solt slot-left">
        <div v-for="item in appointState.soltLeft"
             :key="item.value"
             class="slot-item"
             :class="{ 'active': appointState.selectDay.value === item.value }"
             @click="handleSoltChange('day', item)">
          {{ item.text }}
        </div>
      </div>
      <div ref="soltRight"
           class="picker-solt slot-right">
        <div v-for="item in appointState.soltRight"
             :key="item.value"
             class="slot-item"
             :class="{ 'active': appointState.selectHour.value === item.value }"
             @click="handleSoltChange('hour', item)">
          <span class="slot-item-text">{{ item.text }}</span>
          <i v-show="appointState.selectHour.value === item.value"
             class="iconfont icon-check-circle slot-item-icon" />
          <i v-show="appointState.selectHour.value !== item.value"
             class="iconfont icon-check-button-off slot-item-icon" />
        </div>
      </div>
    </div>
  </popup>
</template>
<script name="appointTimePopup">
import popup from '@/components/popup'
import dateFormat from '@/plugin/dateFormat/dateFormat'
import useAppointTime from '../../js/useWorkAppointTime'
const { createSoltList, setAppointDate } = useAppointTime()
export default {
  name: 'appointTimePopup',
  mixins: [],
  components: {
    popup
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    defaultTimeRang: {
      default: () => ({
        begin: dateFormat(new Date(new Date().setHours(10, 0, 0, 0)), 'yyyy/MM/dd hh:mm'),
        end: dateFormat(new Date(new Date().setHours(17, 0, 0, 0)), 'yyyy/MM/dd hh:mm')
      })
    },
    /**
   * 可预约时间范围
   * @type { begin: string, end: string }
   * @example
   * {
   *  begin:2023/05/02 09:00,
   *  end:2023/05/02 09:00
   * }
   */
    appointTimeRang: {
      default: () => this.defaultTimeRang.default()
    },
    /**
   * 可工作时间范围
   * @type { begin: string, end: string }
   * @example
   * {
   *  begin:2023/05/02 09:00,
   *  end:2023/05/02 09:00
   * }
   */
    workDateTimeRang: {
      default: () => this.defaultTimeRang.default()
    },
    /** 当前已选中的时间值（弹窗打开时回显预选的日期+时段） */
    selectedTime: {
      type: Object,
      default: () => ({ text: '', value: '' })
    }
  },
  data () {
    return {
      appointState: {
        soltLeft: [],
        soltRight: [],
        selectDay: {
          text: '',
          value: ''
        },
        selectHour: {
          text: '',
          value: ''
        }
      }
    }
  },
  computed: {},
  watch: {
    show (val) {
      if (val) {
        this.initData()
      }
    },
    appointTimeRang: {
      handler (newValue, oldValue) {
        this.appointState.selectDay = {
          text: '',
          value: ''
        }
        this.appointState.selectHour = {
          text: '',
          value: ''
        }
        // if (newValue.begin !== oldValue.begin && newValue.end !== oldValue.end) {
        //   this.appointState.selectDay = {
        //     text: '',
        //     value: ''
        //   }
        //   this.appointState.selectHour = {
        //     text: '',
        //     value: ''
        //   }
        // }
      }
    }
  },
  filters: {},
  directives: {},
  created () {},
  mounted () {},
  methods: {
    handleConfirm () {
      this.$emit('confirm', this.getSelectData())
    },
    getSelectData () {
      const afterOneHourTime = Date.now() + (1 * 60 * 60 * 1000)
      let selectData = {
        text: '',
        value: ''
      }
      if (this.appointState.selectHour.value.includes('1小时')) {
        selectData = {
          text: `${this.appointState.selectHour.text}`,
          value: `${dateFormat(new Date(afterOneHourTime), 'yyyy/MM/dd hh:mm:ss')}`
        }
      } else {
        selectData = {
          text: `${this.appointState.selectDay.text} ${this.appointState.selectHour.text}`,
          value: `${this.appointState.selectDay.value} ${this.appointState.selectHour.value}`
        }
      }
      return selectData
    },
    /** solt的选择事件 */
    handleSoltChange (type, data) {
      switch (type) {
        case 'day':
          this.appointState.selectDay = data
          this.createSolt()
          this.appointState.selectHour = this.appointState.soltRight[0]
          this.$refs.soltRight.scrollTop = 0
          break
        case 'hour':
          this.appointState.selectHour = data
          break
        default:
          break
      }
    },
    createSolt () {
      setAppointDate({
        appointTimeRang: this.appointTimeRang,
        workDateTimeRang: this.workDateTimeRang,
        defaultTimeRang: this.defaultTimeRang
      })
      const listArr = createSoltList(this.appointState.selectDay.text)
      this.appointState.soltLeft = listArr[0]
      this.appointState.soltRight = listArr[1]
      return listArr
    },
    initData () {
      this.appointState.soltLeft = []
      this.appointState.soltRight = []
      this.createSolt()
      this.initSelected()
    },
    /** 初始化选择：仅匹配非今天的预选时间，今天保持默认（1小时内上门） */
    initSelected () {
      if (!this.appointState.selectDay.value && !this.appointState.selectHour.value) {
        if (this.selectedTime && this.selectedTime.value) {
          const valStr = this.selectedTime.value
          const spaceIdx = valStr.indexOf(' ')
          const dayVal = spaceIdx > -1 ? valStr.slice(0, spaceIdx) : valStr
          const hourVal = spaceIdx > -1 ? valStr.slice(spaceIdx + 1) : ''
          const todayVal = this.appointState.soltLeft[0]?.value

          // 仅未来日期做匹配，今天保持默认避免误匹配当前时间
          if (dayVal && dayVal !== todayVal) {
            const dayMatch = this.appointState.soltLeft.find(d => d.value === dayVal)
            if (dayMatch) {
              this.appointState.selectDay = dayMatch
              this.createSolt()
              const hourMatch = this.appointState.soltRight.find(h => h.value === hourVal)
              this.appointState.selectHour = hourMatch || this.appointState.soltRight[0]
              return
            }
          }
        }
        this.appointState.selectDay = this.appointState.soltLeft[0]
        this.appointState.selectHour = this.appointState.soltRight[0]
      }
    },
    /** 父组件通过 $refs 调用的公开方法，强制设入初始选中时间 */
    setInitialTime (timeObj) {
      if (!timeObj || !timeObj.value || !this.appointState.soltLeft.length) return
      const valStr = timeObj.value
      const spaceIdx = valStr.indexOf(' ')
      const dayVal = spaceIdx > -1 ? valStr.slice(0, spaceIdx) : valStr
      const hourVal = spaceIdx > -1 ? valStr.slice(spaceIdx + 1) : ''

      const dayMatch = this.appointState.soltLeft.find(d => d.value === dayVal)
      if (dayMatch) {
        this.appointState.selectDay = dayMatch
        this.createSolt()
        // 精确匹配 + 最近匹配（跳过"1小时内上门"等非时间值）
        let hourMatch = this.appointState.soltRight.find(h => h.value === hourVal)
        if (!hourMatch) {
          const targetSeconds = hourVal ? hourVal.split(':').reduce((s, v, i) => s + +v * [3600, 60, 1][i], 0) : Infinity
          let bestDiff = Infinity
          for (const h of this.appointState.soltRight) {
            const parts = (h.value || '').split(':')
            if (parts.length < 2) continue
            const hSeconds = parts.reduce((s, v, i) => s + +v * [3600, 60, 1][i], 0)
            const diff = Math.abs(hSeconds - targetSeconds)
            if (diff < bestDiff) { bestDiff = diff; hourMatch = h }
          }
        }
        this.appointState.selectHour = hourMatch || this.appointState.soltRight[0]
      }
    }
  }
}

</script>
<style lang="scss" scoped>
@import "./index";
</style>
